import React, { useState, useEffect } from 'react';
import {
  INepalCount,
  fetchNepalLiveCountAPI
} from 'src/services/api/covidCases';
import UpdateNepalCasesForm from './UpdateNepalCasesForm';

const UpdateNepalCases: React.FC = () => {
  const [formData, setFormData] = useState<INepalCount>({} as INepalCount);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    fetchNepalData();
  }, []);

  const fetchNepalData = async () => {
    try {
      const response = await fetchNepalLiveCountAPI();
      setFormData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoaded(true);
    }
  };

  return (
    <div className="container">
      <h4 className="text-center" style={{ margin: '20px' }}>
        Update Nepal Cases Count
      </h4>
      {isLoaded ? (
        <UpdateNepalCasesForm nepalCounts={formData} />
      ) : (
        <p className="text-center">Loading...</p>
      )}
    </div>
  );
};

export default UpdateNepalCases;
